import axios from 'axios';
import baseUrl from '../config/baseURL';
import { getAuthToken } from '../services/auth';

export const createUtilityTemplate = async (
  organization_id: string,
  pageId: string,
  payload: {
    name?: string;
    template_name?: string;
    language: string;
    body_text: string;
    category?: 'UTILITY';
    trigger?: string;
  },
) => {
  const token = await getAuthToken();

  try {
    if (!token?.success || !token.data) {
      return { success: false, data: 'Token does not exist' };
    }

    const headers = {
      Authorization: `Bearer ${token.data}`,
      'Content-Type': 'application/json',
    };

    const endpoint = `${baseUrl}/core/organizations/${organization_id}/facebook-account/${pageId}/utility-messages/`;
    const response = await axios.post(endpoint, payload, { headers });

    if (response.status >= 200 && response.status < 300) {
      return { success: true, data: response.data };
    }

    return { success: false, data: response.data };
  } catch (error) {
    console.error('Create utility template error:', error);
    return { success: false, data: error };
  }
};

export const getUtilityTemplates = async (
  organization_id: string,
  pageId: string,
) => {
  const token = await getAuthToken();

  try {
    if (!token?.success || !token.data) {
      return { success: false, data: 'Token does not exist' };
    }

    const headers = {
      Authorization: `Bearer ${token.data}`,
    };

    const endpoint = `${baseUrl}/core/organizations/${organization_id}/facebook-account/${pageId}/utility-messages/`;
    const response = await axios.get(endpoint, { headers });

    if (response.status >= 200 && response.status < 300) {
      return { success: true, data: response.data };
    }

    return { success: false, data: response.data };
  } catch (error) {
    console.error('Fetch utility templates error:', error);
    return { success: false, data: error };
  }
};

export const submitUtilityTemplateForApproval = async (
  organization_id: string,
  pageId: string,
  template_id: string,
) => {
  const token = await getAuthToken();

  try {
    if (!token?.success || !token.data) {
      return { success: false, data: 'Token does not exist' };
    }

    const headers = {
      Authorization: `Bearer ${token.data}`,
      'Content-Type': 'application/json',
    };

    const endpoint = `${baseUrl}/core/organizations/${organization_id}/facebook-account/${pageId}/utility-messages/${template_id}/submit_for_approval/`;
    const response = await axios.post(endpoint, {}, { headers });

    if (response.status >= 200 && response.status < 300) {
      return { success: true, data: response.data };
    }

    return { success: false, data: response.data };
  } catch (error) {
    console.error('Submit utility template error:', error);
    return { success: false, data: error };
  }
};

export const sendUtilityTemplate = async (
  organization_id: string,
  conversation_id: string,
  payload: {
    template_id: string;
  },
) => {
  const token = await getAuthToken();

  try {
    if (!token?.success || !token.data) {
      return { success: false, data: 'Token does not exist' };
    }

    const headers = {
      Authorization: `Bearer ${token.data}`,
      'Content-Type': 'application/json',
    };

    const endpoint = `${baseUrl}/core/organizations/${organization_id}/facebook-conversations/${conversation_id}/messages/send-template/`;
    const response = await axios.post(endpoint, payload, { headers });

    if (response.status >= 200 && response.status < 300) {
      return { success: true, data: response.data };
    }

    return { success: false, data: response.data };
  } catch (error) {
    console.error('Send utility template message error:', error);
    return { success: false, data: error };
  }
};
